import * as S from './styled';

function DashboardCard ({ children }) {
  return <S.Container>
    {children}
  </S.Container>;
}

export default DashboardCard;
